export default __webpack_public_path__ + "static/media/avatar12.b8b595e2.svg";